import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { remCalc } from '@lwtears/lwt-common-frontend/lib/@common/util/style-util';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

const t = (key: string, options?) => translate('ui', key, options);

const helpDocuments = [
  {
    href: '/tour/different_and_better.pdf',
    text: 'helpAndSupport.accessDifferentAndBetter',
  },
  {
    href: '/tour/supporting_english_language_learners.pdf',
    text: 'helpAndSupport.accessSupportingEnglishLanguageLearners',
  },
  {
    href: '/tour/help_me_hold_crayons.pdf',
    text: 'helpAndSupport.accessHelpMeHoldCrayonsAndPencils',
  },
  {
    href: '/tour/help_me_write_my_name.pdf',
    text: 'helpAndSupport.accessHelpMeWriteMyName',
  },
  {
    href: '/tour/sing_along_activity_suggestions.pdf',
    text: 'helpAndSupport.accessSingAlongActivitySuggestions',
  },
  {
    href: '/tour/sing_sound_count_activity_suggestions.pdf',
    text: 'helpAndSupport.accessSingSoundAndCountActivitySuggestions',
  },
  {
    href: '/tour/capital_letter_formation_chart.pdf',
    text: 'helpAndSupport.accessCapitalLetterFormationChart',
  },
  {
    href: '/tour/number_formation_chart.pdf',
    text: 'helpAndSupport.accessNumberFormationChart',
  },
];

const HelpAndSupportTiles: React.FC = () => {
  const classes = styles();

  return (
    <>
      <Grid container item xs={12} spacing={2}>
        <Grid item xs={4}>
          <Card className={classes.panel} elevation={4}>
            <CardContent>
              <div className={classes.panelHeader}>
                <Typography variant="h4" className={classes.title}>
                  {t('helpAndSupport.documents')}
                </Typography>
              </div>
              {helpDocuments.map((item, index) => (
                <Typography key={index} color="textPrimary" component="p" variant="subtitle1">
                  <Link target="_blank" rel="noopener noreferrer" href={item.href}>
                    {t(item.text)}
                  </Link>
                </Typography>
              ))}
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Card className={classes.panel} elevation={4}>
            <CardContent>
              <div className={classes.panelHeader}>
                <Typography variant="h4" className={classes.title}>
                  {t('helpAndSupport.contactUs')}
                </Typography>
              </div>
              <Typography color="textPrimary" component="p" variant="subtitle1">
                {t('helpAndSupport.contactUsDescription')}
              </Typography>
              <Typography color="textPrimary" component="p" variant="subtitle1">
                {t('helpAndSupport.contactUsNumber')}
              </Typography>
              <br />
              <Typography color="textPrimary" component="p" variant="subtitle1">
                <b>{t('helpAndSupport.contactUsOfficeHours')}:</b>
              </Typography>
              <Typography color="textPrimary" component="p" variant="subtitle1">
                {t('helpAndSupport.contactUsOfficeHoursDescription')}
              </Typography>
              <br />
              <Typography color="textPrimary" component="p" variant="subtitle1">
                <b>{t('helpAndSupport.augustSeptemberSupportHours')}:</b>
              </Typography>
              <Typography color="textPrimary" component="p" variant="subtitle1">
                {t('helpAndSupport.augustSeptemberSupportHoursDescription1')}
              </Typography>
              <Typography color="textPrimary" component="p" variant="subtitle1">
                {t('helpAndSupport.augustSeptemberSupportHoursDescription2')}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={4}>
          <Card className={classes.panel} elevation={4}>
            <CardContent>
              <div className={classes.panelHeader}>
                <Typography variant="h4" className={classes.title}>
                  {t('helpAndSupport.faqs')}
                </Typography>
              </div>
              <Typography color="textPrimary" component="p" variant="subtitle1">
                <b>{t('helpAndSupport.faq1')}</b>
              </Typography>
              <Typography color="textPrimary" component="p" variant="subtitle1">
                {t('helpAndSupport.faq1Answer')}
              </Typography>
              <br />
              <Typography color="textPrimary" component="p" variant="subtitle1">
                <b>{t('helpAndSupport.faq2')}</b>
              </Typography>
              <Typography color="textPrimary" component="p" variant="subtitle1">
                {t('helpAndSupport.faq2Answer')}
              </Typography>
              <br />
              <Typography color="textPrimary" component="p" variant="subtitle1">
                <b>{t('helpAndSupport.faq3')}</b>
              </Typography>
              <Typography color="textPrimary" component="p" variant="subtitle1">
                {t('helpAndSupport.faq3Answer')}
              </Typography>
              <br />
              <Typography color="textPrimary" component="p" variant="subtitle1">
                <b>{t('helpAndSupport.faq4')}</b>
              </Typography>
              <Typography color="textPrimary" component="p" variant="subtitle1">
                {t('helpAndSupport.faq4Answer')}
              </Typography>
              <br />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default HelpAndSupportTiles;

const styles = makeStyles((theme: any) => ({
  panelLink: {
    padding: theme.spacing(2),
    textDecoration: 'none !important',
  },
  panel: {
    width: '100%',
    height: '100%',
    border: `1px solid ${(theme.palette as any).grey[600]}`,
    padding: theme.spacing(4),
    '&:hover': {
      transform: 'scale(1.01, 1.01)',
      boxShadow: '0 1px 10px 2px rgb(0 0 0 / 20%)',
    },
  },
  panelHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& img': {
      maxHeight: remCalc(60),
      marginRight: theme.spacing(4),
    },
  },
  title: {
    lineHeight: 'normal',
    wordBreak: 'break-all',
  },
  content: {
    padding: theme.spacing(0),
    '&:last-child': {
      paddingBottom: 0,
    },
  },
}));
